import * as React from "react";

import { cn } from "./utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "resize-none border-input placeholder:text-muted-foreground aria-invalid:border-destructive flex field-sizing-content min-h-16 w-full rounded-sm border bg-transparent px-3 py-2 text-base transition-[color,border-color,box-shadow] outline-none focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#4369a0]/25 focus-visible:border-[#4369a0] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
